import { observer } from "mobx-react";
import OrdersView from "./orders-view";

const ManageFinance = observer(() => {
  return (
    <div className="container mt-3 pb-3">
      <div className="row mb-3">
        <h5 className="mb-0 ps-0 text-start border-bottom border-danger-subtle border-4">
          Finance
        </h5>
      </div>
      <OrdersView />
    </div>
  );
});

export default ManageFinance;
